import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {ListService} from '../../services/list.service';
import {IntroductionLetterService} from '../../services/introduction-letter.service';
import {Option, Response} from '../../model/GeneralModels';

export interface RecompenseFormDialogData {
  subsetID: number;
}

@Component({
  selector: 'app-recompense-form',
  templateUrl: './recompense-form.component.html',
  styleUrls: ['./recompense-form.component.css']
})
export class RecompenseFormComponent implements OnInit {
  formGroup: FormGroup = this.fb.group({
    stateID: ['', Validators.required],
    cityID: ['', Validators.required],
    damageAmount: ['', Validators.required],
    damageType: ['', Validators.required],
    dateOfDamage: ['', Validators.required]
  });
  stateList: Option[] = [];
  cityList: Option[] = [];
  constructor(
    public dialogRef: MatDialogRef<RecompenseFormComponent>,
    @Inject(MAT_DIALOG_DATA) public data: RecompenseFormDialogData, private fb: FormBuilder,
    private listService: ListService, private introductionLetterService: IntroductionLetterService) {
    this.data = data;
  }

  ngOnInit(): void {this.listService.getStateList('RECOMPENSE').subscribe(response => {
    this.stateList = [];
    for (let i = 0; i < response.data.states.length; i++) {
      this.stateList[i] = new Option(response.data.states[i].persianName, response.data.states[i].stateCode);
    }
  });
  }

  onStateChange(selectedStateID) {
    this.listService.getCityList('RECOMPENSE', parseInt(selectedStateID, 10)).subscribe((response: Response) => {
      if (!response.data.cities.length) {
        this.cityList[0] = new Option('', 'هشتگ بیمه استان انتخاب شده را پوشش نمی دهد');
      } else {
        this.cityList = response.data.cities;
        for (let i = 0; i < response.data.cities.length; i++) {
          this.cityList[i] = new Option(response.data.cities[i].persianName, response.data.cities[i].cityCode);
        }
      }
      this.formGroup.controls.cityID.patchValue('');
    });
  }

  submit() {
    if (this.formGroup.valid) {
      const form = this.formGroup.value;
      form.subsetID = this.data.subsetID;
      this.introductionLetterService.createNewRecompenseRequest(form).subscribe(response => {
        if (response.success) {
          this.dialogRef.close(true);
        }
      });
    }
  }
}
